import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail } from 'lucide-react';
import './Footer.css';
import logo from '../../assets/kvp.png'; // Assuming updated logo file

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    setSubscribed(true);
    setTimeout(() => setSubscribed(false), 3000); // Reset after 3s
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <motion.div
          className="footer-grid"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="footer-hub">
            <img alt="KVP Trade LTD" className="footer-logo" src={logo} />
            <p className="footer-pitch">
              KVP Trade LTD—your bulk deal HQ since 2025. Stacking pallets, slashing prices, and shipping nationwide from London’s gritty heart.
            </p>
          </div>

          <div className="footer-contacts">
            <h4>Reach the Crew</h4>
            <motion.div className="contact-block" whileHover={{ scale: 1.05 }}>
              <Phone className="contact-marker" size={24} />
              <div>
                <span className="contact-tag">Call Us</span>
                <span className="contact-info">
                  <a href="tel:+447495937969">+44 7495 937969</a>
                </span>
              </div>
            </motion.div>
            <motion.div className="contact-block" whileHover={{ scale: 1.05 }}>
              <Mail className="contact-marker" size={24} />
              <div>
                <span className="contact-tag">Email Us</span>
                <span className="contact-info">
                  <a href="mailto:keyurpat0712@gmail.com">keyurpat0712@gmail.com</a>
                </span>
              </div>
            </motion.div>
            <motion.div className="contact-block" whileHover={{ scale: 1.05 }}>
              <MapPin className="contact-marker" size={24} />
              <div>
                <span className="contact-tag">Find Us</span>
                <span className="contact-info">6 Myrdle Street, London, E1 1EU</span>
              </div>
            </motion.div>
          </div>

          <div className="footer-nav">
            <h4>Dig Deeper</h4>
            <motion.a href="#shop" whileHover={{ scale: 1.05 }}>Bulk Haul</motion.a>
            <motion.a href="#about" whileHover={{ scale: 1.05 }}>Our Story</motion.a>
            <motion.a href="#support" whileHover={{ scale: 1.05 }}>Get Help</motion.a>
          </div>

          <div className="footer-deals">
            <h4>Deal Alerts</h4>
            <form className="deals-form" onSubmit={handleSubscribe}>
              <input
                type="email"
                className="deals-input"
                placeholder="Your Email for Deals"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <motion.button
                type="submit"
                className="deals-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Lock In
              </motion.button>
            </form>
            {subscribed && (
              <motion.p
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                className="deals-confirm"
              >
                You’re in! Bulk deals incoming.
              </motion.p>
            )}
          </div>
        </motion.div>

        <div className="footer-line">
          <p className="footer-signoff">© 2025 KVP Trade LTD. Built for the trade.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;